import { render } from "./OverlaysView.vue?vue&type=template&id=9aad621c"
import script from "./OverlaysView.vue?vue&type=script&lang=js"
export * from "./OverlaysView.vue?vue&type=script&lang=js"

import "./OverlaysView.vue?vue&type=style&index=0&id=9aad621c&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__